import type { NativeHeaderState } from '../../types/native';

export type SignatureHeaderState = { isFormOpen: boolean; canCopy: boolean };

export function signatureNativeButtons(state: SignatureHeaderState | null): NonNullable<NativeHeaderState['navButtons']> {
  if (!state || state.isFormOpen) return [];
  return [{ id: 'profile-signature:menu', sfSymbol: 'ellipsis.circle', label: 'Email signatures', menuItems: [
    ...(state.canCopy ? [
      { id: 'profile-signature:copy-rich', label: 'Copy for Mac Mail', sfSymbol: 'doc.on.doc' },
      { id: 'profile-signature:copy-text', label: 'Copy for iPhone or iPad Mail', sfSymbol: 'iphone' },
    ] : []),
    { id: 'profile-signature:template', label: 'Use Contract Group template', sfSymbol: 'building.2' },
    { id: 'profile-signature:add', label: 'Add signature', sfSymbol: 'plus' },
  ] }];
}

export function dispatchSignatureNativeAction(id: string): boolean {
  if (id === 'profile-signature:menu') return true;
  if (id === 'profile-signature:copy-rich' || id === 'profile-signature:copy-text') {
    window.dispatchEvent(new CustomEvent('profile-signature:copy', { detail: { format: id.endsWith('text') ? 'text' : 'rich' } }));
    return true;
  }
  if (id === 'profile-signature:add' || id === 'profile-signature:template') {
    window.dispatchEvent(new CustomEvent(id));
    return true;
  }
  return false;
}
